import { PartnerGroupModel } from '@/types/models/partnerGroups';
import InputEntity from '@/lib/formFactory/inputEntity';
import CheckboxEntity from "@/lib/formFactory/checkboxEntity";

export default class EntityModel {
    model: PartnerGroupModel;

    constructor() {
        const name = new InputEntity('name');
        name.setTitle('Название');
        name.setRequired(true);

        const sort = new InputEntity('sort');
        sort.setTitle('Сортировка');
        sort.setRequired(true);

        const availableTypes = new CheckboxEntity('isActive');
        availableTypes.setName('Активность');

        this.model = {
            name: name.entity[name.entityName],
            sort: sort.entity[sort.entityName],
            isActive: availableTypes.entity,
        };
    }
}
